<template>
  <fieldset
    class="sb-form-group"
    :class="{
      'sb-form-group--inline': inline,
    }"
  >
    <legend class="sb-form-group__legend">{{ legend }}</legend>

    <div class="sb-form-group__info">
      <p v-if="description" class="sb-form-group__description">
        {{ description }}
      </p>
    </div>
    <div v-if="inline" class="sb-form-group__slot">
      <slot />
    </div>
    <slot v-else />
  </fieldset>
</template>
<script setup lang="ts">
export type SbFormGroupProps = {
  legend: string
  inline?: boolean
  description?: string
}

withDefaults(defineProps<SbFormGroupProps>(), {
  inline: false,
  description: undefined,
})
</script>
